<!-- eslint-disable max-len -->
<template>
  <div class="error-toast">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99984 11.1666L12.4165 13.5833C12.5693 13.7361 12.7637 13.8125 12.9998 13.8125C13.2359 13.8125 13.4304 13.7361 13.5832 13.5833C13.7359 13.4305 13.8123 13.2361 13.8123 13C13.8123 12.7638 13.7359 12.5694 13.5832 12.4166L11.1665 9.99996L13.5832 7.58329C13.7359 7.43052 13.8123 7.23607 13.8123 6.99996C13.8123 6.76385 13.7359 6.5694 13.5832 6.41663C13.4304 6.26385 13.2359 6.18746 12.9998 6.18746C12.7637 6.18746 12.5693 6.26385 12.4165 6.41663L9.99984 8.83329L7.58317 6.41663C7.43039 6.26385 7.23595 6.18746 6.99984 6.18746C6.76373 6.18746 6.56928 6.26385 6.4165 6.41663C6.26373 6.5694 6.18734 6.76385 6.18734 6.99996C6.18734 7.23607 6.26373 7.43052 6.4165 7.58329L8.83317 9.99996L6.4165 12.4166C6.26373 12.5694 6.18734 12.7638 6.18734 13C6.18734 13.2361 6.26373 13.4305 6.4165 13.5833C6.56928 13.7361 6.76373 13.8125 6.99984 13.8125C7.23595 13.8125 7.43039 13.7361 7.58317 13.5833L9.99984 11.1666ZM9.99984 18.3333C8.84706 18.3333 7.76373 18.1145 6.74984 17.677C5.73595 17.2395 4.854 16.6458 4.104 15.8958C3.354 15.1458 2.76025 14.2638 2.32275 13.25C1.88525 12.2361 1.6665 11.1527 1.6665 9.99996C1.6665 8.84718 1.88525 7.76385 2.32275 6.74996C2.76025 5.73607 3.354 4.85413 4.104 4.10413C4.854 3.35413 5.73595 2.76038 6.74984 2.32288C7.76373 1.88538 8.84706 1.66663 9.99984 1.66663C11.1526 1.66663 12.2359 1.88538 13.2498 2.32288C14.2637 2.76038 15.1457 3.35413 15.8957 4.10413C16.6457 4.85413 17.2394 5.73607 17.6769 6.74996C18.1144 7.76385 18.3332 8.84718 18.3332 9.99996C18.3332 11.1527 18.1144 12.2361 17.6769 13.25C17.2394 14.2638 16.6457 15.1458 15.8957 15.8958C15.1457 16.6458 14.2637 17.2395 13.2498 17.677C12.2359 18.1145 11.1526 18.3333 9.99984 18.3333Z"
        fill="#EE3C31" />
    </svg>

    <div class="error-toast__wrapper">
      <h2 class="error-toast__title">{{ title }}</h2>
      <span v-if="description" class="error-toast__description">{{ description }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorToast',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.error-toast {
  display: flex;
  align-items: flex-start;
  gap: 8px;

  &__title {
    color: #111724;
    font-family: "GT Walsheim Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }

  &__description {
    color: #111724;
    font-family: "GT Walsheim Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
}
</style>
